import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api";
import { Card, Btn, Spinner } from "@/components/ui-kit";
import { StatCard, SectionTitle, EmptyState, CampaignCard, ProComingSoon } from "@/components/dashboard-bits";
import { InstagramPromo } from "@/components/InstagramPromo";
import { Megaphone, FileText, MessageSquare } from "lucide-react";

export default function CreatorDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/dashboard/creator").then((r) => setData(r.data)); }, []);
  if (!data) return <Spinner />;

  return (
    <div className="space-y-10" data-testid="creator-dashboard">
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        <StatCard label="Avoimet kampanjat" value={data.stats.open_campaigns} tone="accent" icon={Megaphone} to="/dashboard/kampanjat" />
        <StatCard label="Omat hakemukset" value={data.stats.my_applications} tone="secondary" icon={FileText} to="/dashboard/hakemukset" />
        <StatCard label="Viestit" value={data.stats.messages} tone="gray" icon={MessageSquare} to="/dashboard/viestit" />
      </div>

      <InstagramPromo role="creator" />

      <ProComingSoon features={[
        "Anna Pro-yritysten löytää sinut ja ottaa yhteyttä suoraan ilman kampanjaa.",
        "Lähetä rajattomasti hakemuksia.",
        "Korostettu profiili.",
        "Parempi näkyvyys yrityksille.",
        "Tulevat AI-ominaisuudet sisältyvät Pro-jäsenyyteen.",
      ]} />

      <div>
        <SectionTitle action={<Btn to="/dashboard/kampanjat" variant="ghost" className="text-sm">Katso kaikki</Btn>}>
          Suositellut kampanjat
        </SectionTitle>
        {data.latest_campaigns.length === 0 ? (
          <EmptyState title="Ei avoimia kampanjoita" subtitle="Uudet kampanjat näkyvät täällä." />
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {data.latest_campaigns.map((c) => (
              <Link key={c.campaign_id} to="/dashboard/kampanjat" className="block min-w-0"><CampaignCard c={c} /></Link>
            ))}
          </div>
        )}
      </div>

      <div>
        <SectionTitle action={<Btn to="/dashboard/hakemukset" variant="ghost" className="text-sm">Katso kaikki</Btn>}>
          Viimeisimmät hakemukset
        </SectionTitle>
        {data.applications.length === 0 ? (
          <EmptyState title="Et ole vielä hakenut kampanjoihin" subtitle="Selaa kampanjoita ja lähetä ensimmäinen hakemuksesi." />
        ) : (
          <Card className="divide-y divide-[#E6E1D9]">
            {data.applications.map((a) => (
              <Link key={a.application_id} to="/dashboard/hakemukset" className="block px-6 py-4 hover:bg-[#F5F3F0] transition-colors" data-testid="application-row">
                <p className="font-medium text-[#292827]">{a.campaign_title}</p>
                <p className="text-sm text-[#968F85] mt-0.5">{a.created_at?.slice(0, 10)}</p>
              </Link>
            ))}
          </Card>
        )}
      </div>
    </div>
  );
}
